module.exports = __webpack_public_path__ + "img/C08TechMahoutMastery_ua.17b05b2f.webp";